<script setup lang="ts">
import FileViewerHost from '@/ui/components/FileViewerHost/index.vue'
import { provideFileViewer } from '@/utils/composables/useFileViewer'
import enUs from 'element-plus/es/locale/lang/en.mjs'
import zhCN from 'element-plus/es/locale/lang/zh-cn.mjs'
import { useI18n } from 'vue-i18n'

const settingsStore = useSettingsStore()
const { locale } = useI18n()
provideFileViewer()

// 根据当前语言选择对应的 Element Plus 语言包
const currentLocale = computed(() => {
  return locale.value === 'zh-cn' ? zhCN : enUs
})

const isDark = computed(() => {
  const colorScheme = settingsStore.currentColorScheme

  if (colorScheme === 'dark') {
    return true
  }
  if (colorScheme === 'light') {
    return false
  }
  return document.documentElement.classList.contains('dark')
})

// 跟随框架主题
const isSupprotColorMix = CSS.supports('color', 'color-mix(in srgb, #fff, #000)')
if (isSupprotColorMix) {
  document.body.style.setProperty('--el-bg-color', 'hsl(var(--background))')
  document.body.style.setProperty('--el-color-primary', 'hsl(var(--primary))')
  document.body.style.setProperty('--el-color-white', 'hsl(var(--primary-foreground))')
  document.body.style.setProperty('--el-color-black', 'hsl(var(--primary-foreground))')
  watch(() => settingsStore.currentColorScheme, (val) => {
    if (val === 'light') {
      for (let index = 1; index < 10; index++) {
        document.body.style.setProperty(`--el-color-primary-light-${index}`, `color-mix(in hsl, hsl(var(--primary)), #fff ${index * 10}%)`)
        document.body.style.setProperty(`--el-color-primary-dark-${index}`, `color-mix(in hsl, hsl(var(--primary)), #000 ${index * 10}%)`)
      }
    }
    else {
      for (let index = 1; index < 10; index++) {
        document.body.style.setProperty(`--el-color-primary-light-${index}`, `color-mix(in hsl, hsl(var(--primary)), #000 ${index * 10}%)`)
        document.body.style.setProperty(`--el-color-primary-dark-${index}`, `color-mix(in hsl, hsl(var(--primary)), #fff ${index * 10}%)`)
      }
    }
  }, {
    immediate: true,
  })
}
</script>

<template>
  <ElConfigProvider :locale="currentLocale" :button="{ autoInsertSpace: true }">
    <VanConfigProvider class="h-full" :theme="isDark ? 'dark' : 'light'">
      <slot />
      <FileViewerHost />
    </VanConfigProvider>
  </ElConfigProvider>
</template>
